import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { post } from '../../helpers/api_helper';
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ForgotPasswordForm() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleResetClick = async() => {
    setLoading(true)
    try {
    const response = await post('/forgot-password', {
      email: email, 
    });

    
    if (response.message && response.status === "1") {
       toast.success(`Password reset link sent successfully on ${email}`)
    }
    window.location.href="/reset-password-sent"
    
  } catch (error) {
    toast.error("User not found.Please input correct email")
  } 
  setLoading(false)
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 ">
      <div className="max-w-md w-full space-y-8 shadow-2xl p-6 rounded-md">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Forgot Your Password?
          </h2>
        </div>
        <form className="mt-8 space-y-6" action="#" method="POST">
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="button"
              onClick={handleResetClick}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#ee5535] hover:bg-[#af3921]  hover:tracking-wider focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Reset Password {loading?<ClipLoader size={20} color='white' className='ml-2'/>:""}
            </button>
          </div>
        </form>
      </div>
      <ToastContainer/>
    </div>
  );
}

export default ForgotPasswordForm;